
<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher une analyse..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>

    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">

            <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-hover">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()"/>
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding: 20px">
                            <mat-checkbox [checked]="selectedAll" (change)="handleChecked(element)"/>
                        </td>
                    </ng-container>
                    <!-- Sample Code -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Échantillon</th>
                        <td mat-cell *matCellDef="let element">{{ element.code }}</td>
                    </ng-container>
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date début</th>
                        <td mat-cell *matCellDef="let element">{{ element.startDate | date:'short' }}</td>
                    </ng-container>
                    <!-- Date Analyse -->
                    <ng-container matColumnDef="dateAnalyse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Analyse</th>
                        <td mat-cell *matCellDef="let element">{{ element.dateAnalyse | date:'short' }}</td>
                    </ng-container>

                    <!-- Date Analyse -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date fin</th>
                        <td mat-cell *matCellDef="let element">{{ element.endDate | date:'short' }}</td>
                    </ng-container>
                    <!-- Nombre d’analyses -->
                    <ng-container matColumnDef="resultsCount">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                        Nombre d'Analyses
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                        {{ element.resultsCount }}
                    </td>
                    </ng-container>


        <!-- Actions -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element" >
                        <button mat-icon-button color="primary" (click)="openSampleDetailsModal(element, sampleDetailsModal)" matTooltip="Voir détails" >
                          <i class="material-symbols-outlined">visibility</i>
                        </button>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['select','sampleCode','startDate','dateAnalyse','endDate','resultsCount','action']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['select','sampleCode','startDate','dateAnalyse','endDate','resultsCount','action']"></tr>

            </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
<ng-template #sampleDetailsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Analyses du Echantillon {{ selectedSample?.code }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th>Référence</th>
          <th>Paramètre</th>
          <th>Date de début</th>
          <th>Date de fin</th>
          <th>Résultat finale</th>
          <th>Validé</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let res of selectedSample?.analyses">
          <td>{{ res.refAnalyse }}</td>
          <td>{{ res.parameterName }}</td>
          <td>{{ res.startDate | date:'short' }}</td>
          <td>{{ res.endDate | date:'short' }}</td>
          <td>{{ res.resultatFinale || 'N/A' }}</td>
          <td>{{ res.valide ? 'Oui' : 'Non' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<!-- Add modal template for nv -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Affecter un utilisateur.
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="affectUser()">
                <mat-form-field class="mb-25">
                    <mat-label>Utilisateurs</mat-label>
                    <mat-select formControlName="userId">
                        <mat-option *ngFor="let user of userList" [value]="user.id">
                            {{ user.username }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('userId')?.hasError('required')">Champ obligatoire
                    </mat-error>
                </mat-form-field>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-outline-primary">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Update Analyse
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm">
                <div class="row">

                    <!-- refAnalyse -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Reference</mat-label>
                            <input readonly matInput formControlName="refAnalyse" placeholder="Ex. A12345">
                            <mat-error *ngIf="editForm.get('refAnalyse')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- startDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Start Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker1" formControlName="startDate"
                                   placeholder="Select start date">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error *ngIf="editForm.get('startDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- endDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>End Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker2" formControlName="endDate"
                                   placeholder="Select end date">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="editForm.get('endDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- Statut-->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="status" placeholder="Select a client">
                                <mat-option [value]="0">En éxecusion</mat-option>
                                <mat-option [value]="1">Termié</mat-option>
                            </mat-select>
                            <mat-error *ngIf="editForm.get('status')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- sample -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Sample</mat-label>
                            <input matInput readonly formControlName="sampleCode">
                        </mat-form-field>
                    </div>

                    <!-- parameter -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Parametre</mat-label>
                            <input matInput readonly formControlName="parameterName">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Utilisateurs</mat-label>
                            <mat-select formControlName="userId" placeholder="Select a client">
                                <mat-option *ngFor="let user of userList" [value]="user.id">
                                    {{ user.username }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- poids -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Poids</mat-label>
                            <input type="number" matInput formControlName="poids">
                            <mat-error *ngIf="editForm.get('poids')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                     resultat -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat
                            </mat-label>
                            <input type="number" matInput formControlName="resultat">
                            <mat-error *ngIf="editForm.get('resultat')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- resultatFinale -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat finale</mat-label>
                            <input type="number" matInput formControlName="resultatFinale">
                            <mat-error *ngIf="editForm.get('resultatFinale')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- commentaire -->
                    <div class="col-sm-8">
                        <mat-form-field class="mb-25">
                            <mat-label>Comment</mat-label>
                            <textarea matInput formControlName="commentaire" placeholder="Enter comment"></textarea>
                            <mat-error *ngIf="editForm.get('commentaire')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-outline-success">Enregister</button>
                    </div>

                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bolder text-secondary">Détails analyse :</h5>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom du paramètre :</div>
                    <p>{{ analyse?.parameterName }}</p>
                </div>

                <!-- Analyse Reference -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Référence Analyse :</div>
                    <p>{{ analyse?.refAnalyse }}</p>
                </div>

                <!-- Sample Details -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Code Échantillon :</div>
                    <p>{{ analyse?.sampleCode }}</p>
                </div>

                <!-- Analysis Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Début :</div>
                    <p>{{ analyse?.startDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Fin :</div>
                    <p>{{ analyse?.endDate | date : "short" }}</p>
                </div>

                <!-- Status -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Statut :</div>
                    <p>{{ analyse?.status ? "Termié" : "En éxecusion" }}</p>
                </div>

                <!-- Creation and Update Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créé le :</div>
                    <p>{{ analyse?.creationDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Modifié le :</div>
                    <p>{{ analyse?.updateDate | date : "short" }}</p>
                </div>

                <!-- Created By -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créateur :</div>
                    <p>{{ analyse?.appUserName }}</p>
                </div>

                <!-- Poids -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Poids :</div>
                    <p>{{ analyse?.poids }} Kg</p>
                </div>

                <!-- resultat -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat :</div>
                    <p>{{ analyse?.resultatBrute }}</p>
                </div>

                <!-- resultatFinale -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat Finale :</div>
                    <p>{{ analyse?.resultatFinale }}</p>
                </div>


                <!-- Comment -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Commentaire :</div>
                    <p>{{ analyse?.commentaire }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>


